module.exports = __webpack_public_path__ + "img/result-01.937dadb9.jpg";